import { render, staticRenderFns } from "./ModificaResponsabile.vue?vue&type=template&id=7076a01e&scoped=true&"
import script from "./ModificaResponsabile.vue?vue&type=script&lang=js&"
export * from "./ModificaResponsabile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7076a01e",
  null
  
)

export default component.exports